import { RemoteRecurringPushNotification } from 'data/usecases/push-notification/remote-recurring-push-notification';
import { RecurringPushNotificationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlRecurringPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRecurringPushNotification =
  (): RecurringPushNotificationUseCaseInterface => {
    return new RemoteRecurringPushNotification(
      makeApiUrlRecurringPushNotification(),
      makeAxiosHttpClient(),
    );
  };
